class Permission {
  constructor(brand) {
    this.brand = brand;

    this.customer_create = false;
    this.customer_show = false;
    this.customers_index = false;
    this.customer_block_streatus = false;
    this.customer_set_web_app_id = false;

    this.inquiries_index = false;
    this.inquiry_create = false;
    this.inquiry_create_master = false;
    this.inquiry_show = false;
    this.inquiry_hard_delete = false;

    this.invoice_paid = false;
    this.invoice_pause = false;
    this.invoice_resume = false;
    this.invoices_index = false;
    this.invoice_exact_import = false;
    this.invoice_exact_export = false;
    this.invoice_resend = false;
    this.invoice_edit_note = false;

    this.order_create = false;
    this.order_show = false;
    this.orders_index = false;
    this.order_complete = false;
    this.order_terminate = false;
    this.order_add_connectivity = false;
    this.order_cancel = false;
    this.order_item_quantity_edit = false;
    this.order_add_device = false;
    this.order_add_item = false;
    this.order_uncomplete_delete = false;
    this.order_item_price_edit = false;
    this.order_note_edit = false;

    this.order_service_index = false;
    this.order_service_tab = false;
    this.order_service_create_replace = false;
    this.order_service_create_install = false;
    this.order_service_create_remove = false;
    this.order_service_edit_request_replace = false;
    this.order_service_edit_request_install = false;
    this.order_service_edit_request_remove = false;

    this.permissions_edit = false;
    this.permissions_show = false;
    this.permissions_index = false;

    this.price_list_edit = false;
    this.price_list_index = false;
    this.price_list_show = false;

    this.credit_create = false;

    this.device_actions = false;
    this.devices_index = false;
    this.device_transfer = false;

    this.installations_index = false;
    this.installation_request = false;

    this.kpi_devices = false;
    this.kpi_finance = false;
    this.super_admin = false;

    this.import_tool = false;
    this.create_device_event = false;
    this.create_device_event_custom_agent = false;
    this.synatec_orders_index = false;
    this.synatec_order_create = false;
    this.synatec_order_edit = false;
    this.synatec_order_request = false;
    this.manage_synatec_products = false;
    this.customers_merge = false;
  }
}

export default Permission;
